export const toFieldName = (label) =>
    label
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_-]/g, '')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '');

export const mapComponentFieldToAPIField = (field) => ({
    field_name: toFieldName(field.label || "Image"),
    label: field.label || "Image",
    field_type: field.type,
    placeholder: field.placeholder,
    options: field.options,
    description: field.type === "form-header" ? field.description : undefined,
    showDivider: field.type === "form-header" ? field.showDivider : undefined,
    image_url: field.type === "image" ? field.image_url : undefined,
    alt_text: field.type === "image" ? field.alt_text : undefined,
    required: !!field.required,
    conditions: field.conditions ? Object.keys(field.conditions).reduce((acc, key) => {
        if (field.conditions[key].enabled) {
        acc[key] = {
            enabled: true,
            fields: field.conditions[key].fields.map(conditionalField => ({
            field_name: conditionalField.label,
            label: conditionalField.label,
            field_type: conditionalField.type,
            required: conditionalField.required
            }))
        };
        }
        return acc;
    }, {}) : undefined
});